module.exports = __webpack_public_path__ + "static/dining-fb753f2b33545ef7a437f29e3cf0782d.jpg";